import { render } from "./aio-login-login-link.vue?vue&type=template&id=25c33e9f&scoped=true"
import script from "./aio-login-login-link.vue?vue&type=script&lang=js"
export * from "./aio-login-login-link.vue?vue&type=script&lang=js"

import "./aio-login-login-link.vue?vue&type=style&index=0&id=25c33e9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c33e9f"]])

export default __exports__